import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

export default function SortableItem({id, children}: { id: string, children: React.ReactNode }) {
  const {
      isDragging,
    setNodeRef,
    transform,
    transition,
  } = useSortable({id: id});

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
      <div ref={setNodeRef} style={style} className={isDragging ? 'dnd-dragged' : undefined}>
        {/* ... */}
        {children}
    </div>
  );
}
